import { analytics } from "@/lib/analytics";

const stats = [
  { value: "12", label: "cultural themes" },
  { value: "3-tier", label: "tenant isolation" },
  { value: "2", label: "products shipping" },
];

export function Hero() {
  return (
    <section className="relative overflow-hidden px-6 pb-24 pt-32 md:pt-40">
      {/* Subtle gradient background */}
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(ellipse 80% 50% at 50% -20%, var(--su-accent-subtle, rgba(26,58,91,0.08)) 0%, transparent 70%)",
        }}
        aria-hidden="true"
      />

      <div className="mx-auto max-w-4xl text-center">
        <p className="text-sm font-semibold uppercase tracking-widest text-su-accent">
          Open Platform Framework
        </p>

        <h1 className="mt-4 text-4xl font-bold tracking-tight text-su-text-primary sm:text-5xl md:text-6xl">
          The foundation your
          <br className="hidden sm:block" />
          next SaaS ships on
        </h1>

        <p className="mx-auto mt-4 text-base text-su-text-tertiary">
          Not a starter kit. The same infrastructure shipping in
          brandsyncup.com and legalsyncup.com.
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-su-text-secondary md:text-xl">
          Multi-tenant architecture, graduated auth, and 12 culturally-grounded
          design themes — so every product you build starts with production
          infrastructure, not boilerplate.
        </p>

        {/* Install command — one line to get started */}
        <div className="mx-auto mt-8 max-w-md">
          <div className="overflow-hidden rounded-lg border border-neutral-700 bg-neutral-900">
            <div className="flex items-center justify-between px-4 py-2">
              <span className="text-xs text-neutral-500">terminal</span>
            </div>
            <div className="px-4 pb-3">
              <code className="text-sm text-green-400">
                <span className="select-none text-neutral-500">$ </span>
                pnpm add @syncupsuite/themes
              </code>
            </div>
          </div>
          <p className="mt-2 text-xs text-su-text-tertiary">
            or activate the full platform:{" "}
            <code className="rounded bg-su-surface px-1.5 py-0.5 text-xs text-su-accent">
              /webplatform4sync:shu
            </code>{" "}
            in Claude Code
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="#marketplace"
            onClick={() => analytics.marketplaceInstallCTAClicked()}
            className="inline-flex items-center gap-2 rounded-lg bg-su-accent px-6 py-3 text-sm font-medium text-white shadow-sm transition-colors hover:bg-su-accent-hover"
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Install Claude Code Plugin
          </a>
          <a
            href="https://docs.syncupsuite.com/quick-start"
            onClick={() => analytics.docsCTAClicked()}
            className="inline-flex items-center gap-2 rounded-lg border border-su-border px-6 py-3 text-sm font-medium text-su-text-primary transition-colors hover:border-su-accent hover:text-su-accent"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read the Docs
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
        </div>

        {/* Stats bar */}
        <div className="mx-auto mt-16 flex max-w-lg items-center justify-center gap-8 border-t border-su-border pt-8 sm:gap-12">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-2xl font-bold text-su-text-primary">
                {s.value}
              </p>
              <p className="mt-1 text-xs text-su-text-tertiary">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Community signals */}
        <div className="mt-6 flex items-center justify-center gap-4">
          <a
            href="https://github.com/syncupsuite/themes"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.shields.io/github/stars/syncupsuite/themes?style=flat-square&label=stars&color=1a3a5b"
              alt="GitHub stars"
              height="20"
              loading="lazy"
            />
          </a>
          <a
            href="https://www.npmjs.com/package/@syncupsuite/themes"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.shields.io/npm/dw/@syncupsuite/themes?style=flat-square&label=npm%20downloads&color=1a3a5b"
              alt="npm weekly downloads"
              height="20"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
